export type AccountCapabilities = {
  pricingHubEnabled: boolean
  pricingHubUrl?: string
}

export type AccountCapabilitiesFetchResult = {
  capabilities: AccountCapabilities
  loadError: boolean
}

const FAILED_FETCH_RESULT: AccountCapabilitiesFetchResult = {
  capabilities: { pricingHubEnabled: false },
  loadError: true,
}

function parseAccountCapabilities(data: unknown): AccountCapabilitiesFetchResult | null {
  if (!data || typeof data !== 'object' || Array.isArray(data)) {
    return null
  }

  const record = data as Record<string, unknown>
  const raw = record.accountCapabilities
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) {
    return null
  }

  const caps = raw as Record<string, unknown>
  if (typeof caps.pricingHubEnabled !== 'boolean') {
    return null
  }

  const capabilities: AccountCapabilities = {
    pricingHubEnabled: caps.pricingHubEnabled,
  }

  if (typeof caps.pricingHubUrl === 'string' && caps.pricingHubUrl.trim()) {
    capabilities.pricingHubUrl = caps.pricingHubUrl.trim()
  }

  return {
    capabilities,
    loadError: false,
  }
}

export async function fetchAccountCapabilities(
  endpoint: string,
  jazelId: string,
  opts?: { token?: string },
): Promise<AccountCapabilitiesFetchResult> {
  const base = String(endpoint || '').replace(/\/+$/g, '')
  const url = `${base}/pricing-hub-settings/${encodeURIComponent(jazelId)}`

  const headers: Record<string, string> = {}
  const token = String(opts?.token || '').trim()
  if (token) headers.Authorization = `Bearer ${token}`

  try {
    const resp = await fetch(url, { headers })
    if (!resp.ok) return FAILED_FETCH_RESULT

    let json: unknown
    try {
      json = await resp.json()
    } catch {
      return FAILED_FETCH_RESULT
    }

    const parsed = parseAccountCapabilities((json as any)?.data)
    if (!parsed) return FAILED_FETCH_RESULT

    return parsed
  } catch {
    return FAILED_FETCH_RESULT
  }
}
